import { InjectionToken, Signal, computed, inject } from '@angular/core';
import { ProfileService } from '../services';

/**
 * @description
 * match a specific process identifier to an existing (stored) value in session. for example:
 * query literal might be "card" | "loan" | "upsell". these predefined values are checked against
 * the current process id stored in session value to resolve a match.
 *
 * this is a factory function! which means it (or its consumer functions below) cannot be called
 * out of injection context. if we do need to resolve a match to process outside injection context
 * we can use these functions be injecting the data with injection token and provide a factory
 *
 * @param processId a process literal to query against the stored value
 * @returns an async boolean. true - if query value matches the stored value
 */

export const IS_CARD_PROCESS = new InjectionToken<Signal<boolean>>('isCardProcess', {
  providedIn: 'root',
  factory: () => {
    const isCardMatch = inject(ProfileService).matchCard;
    // Console.logWarning(`IS_CARD_PROCESS: ${isCardMatch()}`);
    return isCardMatch;
  }
});

/** any loan process (currently can match either BNPL | ACFL loans - see below) */
export const IS_LOAN_PROCESS = new InjectionToken<Signal<boolean>>('isLoanProcess', {
  providedIn: 'root',
  factory: () => {
    const isLoanMatch = inject(ProfileService).matchLoan;
    // Console.logWarning(`IS_LOAN_P ROCESS: ${isLoanMatch()}`);
    return isLoanMatch;
  }
});

/** A.C.F.L means "Account Frame Loan" => (הלוואה ממסגרת החשבון) הלוואה ללא כרטיס */
export const IS_ACFL_PROCESS = new InjectionToken<Signal<boolean>>('isAcflProcess', {
  providedIn: 'root',
  factory: () => {
    const isAcflMatch = inject(ProfileService).matchAcfl;
    // Console.logWarning(`IS_ACFL_PROCESS: ${isAcflMatch()}`);
    return isAcflMatch;
  }
});

/** B.N.P.L => "Buy Now Pay Later" Loan */
export const IS_BNPL_PROCESS = new InjectionToken<Signal<boolean>>('isBnplProcess', {
  providedIn: 'root',
  factory: () => {
    const isBnplMatch = inject(ProfileService).matchBnpl;
    // Console.logWarning(`IS_BNPL_PROCESS: ${isBnplMatch()}`);
    return isBnplMatch;
  }
});

export const canMatchCard$$ = computed<boolean>(() => inject(IS_CARD_PROCESS)());

export const canMatchLoan$$ = computed<boolean>(() => inject(IS_LOAN_PROCESS)());

export const canMatchBnpl$$ = computed<boolean>(() => inject(IS_BNPL_PROCESS)());

export const canMatchAnyLoan$$ = computed<boolean>(() => inject(IS_LOAN_PROCESS)());
